var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "users" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 50, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "用户名", "label-width": 60 } },
                        [
                          _c("Input", {
                            attrs: { clearable: true },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "真实姓名", "label-width": 70 } },
                        [
                          _c("Input", {
                            attrs: { clearable: true },
                            model: {
                              value: _vm.search.realName,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "realName", $$v)
                              },
                              expression: "search.realName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "账号类型", "label-width": 70 } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.accountType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "accountType", $$v)
                                },
                                expression: "search.accountType",
                              },
                            },
                            _vm._l(_vm.accountTypeList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "微信登录", "label-width": 70 } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.weixinLogin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "weixinLogin", $$v)
                                },
                                expression: "search.weixinLogin",
                              },
                            },
                            _vm._l(_vm.weixinLoginList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "5px",
                display: "flex",
                width: "100%",
              },
              attrs: { slot: "extra" },
              slot: "extra",
            },
            [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { size: "small", icon: "md-add", type: "primary" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "row-class-name": _vm.tableRowClassName,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
              height: "40px",
            },
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "id",
              label: "编号",
              "min-width": "50",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "用户名",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "realName",
              label: "真实姓名",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "roleName",
              label: "角色",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "accountType",
              label: "账号类型",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: row.accountType === 2 ? "danger" : "primary",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            row.accountType === 1
                              ? "正式账号"
                              : row.accountType === 2
                              ? "临时账号"
                              : ""
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "weixinLogin",
              label: "微信登录",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: row.weixinLogin === 2 ? "danger" : "primary",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            row.weixinLogin === 1
                              ? "开启"
                              : row.weixinLogin === 2
                              ? "停用"
                              : ""
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "remark",
              label: "备注",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "creator",
              label: "创建人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.creatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.creator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "createTime",
              label: "创建时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "updateTime",
              label: "最后操作时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditStatus(row, null, row.status)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "80",
              id: "elPopoverVisible",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v("  \n        "),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "Modal",
        {
          ref: "modalRef",
          attrs: {
            width: "30%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("UserEdit", {
            ref: "edit",
            attrs: { roles: _vm.roles },
            on: { "on-submit": _vm.handleSubmit },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }